
import Message from '~/config/message.js'
import spbkMixin from '@/mixin/or/spbkMixin'
import { commonfunc } from '~/mixin/common'
import ExbtUnitSkeleton from '~/components/ds/skeletonUnit/ExbtUnitSkeleton.vue'
import ThumbOverlay from '@/components/common/product/ThumbOverlay.vue'
import ShoppingbagButton from '@/components/common/product/ShoppingbagButton.vue'
import ProdPrice from '@/components/common/product/ProdPrice.vue'
import ProdName from '@/components/common/product/ProdName.vue'
import CommonVideo from '~/components/common/CommonVideo.vue'
import CommonImage from '~/components/common/CommonImage.vue'

export default {
  name: 'ProdUnit',
  components: {
    CommonImage,
    CommonVideo,
    ExbtUnitSkeleton,
    ThumbOverlay,
    ShoppingbagButton,
    ProdPrice,
    ProdName
  },
  mixins: [spbkMixin, commonfunc],
  props: {
    item: { // 상품 데이터
      type: [Array, Object],
      default: () => {
        return {}
      }
    },
    idx: { // 상품 index
      type: Number
    },
    unitType: { // 상품 type
      type: String,
      default: 'general'
    },
    listGroup: { // 그룹 상품리스트 사용 여부
      type: Boolean,
      default: false
    },
    review: { // 리뷰 유닛
      type: Boolean,
      default: false
    },
    quantity: { // 수량 노출
      type: Boolean,
      default: false
    },
    close: { // 닫기 버튼 기능
      type: Boolean,
      default: false
    },
    cart: { // 장바구니 버튼 노출/비노출 여부
      type: Boolean,
      default: true
    },
    radio: { // 라디오 선택
      type: Boolean,
      default: false
    },
    contwriter: { // 사용자 등록 상품 type
      type: Boolean,
      default: false
    },
    ranking: { // 링킹 유닛
      type: Boolean,
      default: false
    },
    typeList: { // 리스트 타입
      type: Boolean,
      default: false
    },
    order: { // (메뉴)주문에서만 사용 - 가격 우측 정렬 등
      type: Boolean,
      default: false
    },
    long: { // long type veideo
      type: Boolean,
      default: false
    },
    isLazyLoading: {
      type: Boolean,
      default: false
    },
  },
  data () {
    return {
      num: 0, // 수량
      swiperOpt: { // 세트상품 swiper options
        slidesPerView: 4,
        loop: false,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      newSwiperOpt: { // 신상품 swiper options
        slidesPerView: 3,
        loop: false,
        spaceBetween: 28,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        pagination: {
          el: '.swiper-progress',
          type: 'progressbar'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planBoxSwiperOpt: { // 기획전 (신상품) 박스형 swiper options
        slidesPerView: 1,
        loop: false,
        lazy: true,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      planSwiperOpt: { // 기획전 (신상품) 리스트형 swiper options
        slidesPerView: 2,
        loop: false,
        lazy: true,
        spaceBetween: 8,
        observer: true,
        observeParents: true,
        autoplay: false,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        threshold: 30,
        watchOverflow: true // 슬라이드가 1개 일 때 pager, button 숨김 여부 설정
      },
      mbEid: this.$store.getters['session/getMbEid'],
      mb: this.$store.getters['session/getMb'],
      listYn: true,
      adltCtfcYn: this.$store.getters['session/getAdltCtfcYn'], // 성인인증 여부 결과코드 01: 인증 02: 미인증 03: 인증만료(인증 후 1년초과))
      adltCtfcCd: this.$store.getters['session/getAdltCtfcCd'],
      sbpkSingle: {
        pdNo: '',
        spbkQy: '',
        spbkSeCd: '',
        chnlCd: '',
        onldPdNo: '',
        lsUpdrId: 'TestAddSpbk'

      },
      activeExbt: false,
      observer: {},
      videoOptions: { // video 기본 옵션 설정
        controls: false, // 컨트롤 바 노출 여부
        autoplay: false, // 자동재생
        muted: true, // 음소거
        loop: true,
        // poster: imageUrl,
        playsinline: true, // 아이폰에서 자동재생 안되는 경우
        preload: 'auto', // 즉시 비디오 데이터를 다운로드 시작할지 여부 결정

        playbackRates: [1] // 배속
      }
    }
  },
  computed: {
    reviewNum () { // 23.08.25 수정
      if (typeof this.item.reviewNum === 'number') {
        if (this.item.reviewNum > 9999 && this.item.reviewNum <= 99999) {
          return '9.9+ 천'
        } else if (this.item.reviewNum > 99999) {
          return '99.9+ 만'
        } else {
          return Number(this.item.reviewNum).toLocaleString('ko-KR')
        }
      } else if (this.item.reviewNum === 'string') {
        if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 9999 && Number(this.item.reviewNum.replace(/[^0-9]/g, '')) <= 99999) {
          return '9,9+ 천'
        } else if (Number(this.item.reviewNum.replace(/[^0-9]/g, '')) > 99999) {
          return '99,9+ 만'
        }
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(this.item.reviewNum.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    total () { // 23.08.25 수정
      if (typeof this.item.total === 'number') {
        if (this.item.total > 9999 && this.item.total <= 99999) {
          return '9.9+ 천'
        } else if (this.item.total > 99999) {
          return '99.9+ 만'
        } else {
          return Number(this.item.total).toLocaleString('ko-KR')
        }
      } else if (typeof this.item.total === 'string') {
        if (Number(this.item.total.replace(/[^0-9]/g, '')) > 9999 && Number(this.item.total.replace(/[^0-9]/g, '')) <= 99999) {
          return '9.9+ 천'
        } else if (Number(this.item.total.replace(/[^0-9]/g, '')) > 99999) {
          return '99.9+ 만'
        }
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      } else {
        return Number(this.item.total.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    rankFlag () {
      if (typeof this.item.ranking.variance === 'number') {
        if (this.item.ranking.variance === 0) { // 변동없음
          return ''
        } else { // up & down
          return Math.abs(this.item.ranking.variance)
        }
      } else {
        return 'new'
      }
    },
    pagePath () {
      return this.$route.path
    },
  },
  watch: {
  },
  created () {
  },
  mounted () {
    if (document.querySelectorAll('.goods-list.ugc.masonry').length > 0) {
      this.unitHeight()
    }
    this.exbtLazyControl()
    this.$nextTick(() => {
      this.$nuxt.$emit('page-mounted')
    })
    console.log('1053')
  },
  activated () {
    console.log('activated')
    this.exbtLazyControl()
    this.$nuxt.$emit('completeExbtMount')
  },
  deactivated () {
    if (this.observer && typeof this.observer?.disconnect === 'function') {
      this.observer.disconnect()
    }
  },
  beforeDestroy () {
    if (this.observer && typeof this.observer?.disconnect === 'function') {
      this.observer.disconnect()
    }
  },
  unmounted () {
  },
  methods: {
    prodNum (e) {
      if (typeof e === 'number') {
        if (e > 99999) {
          return '99,999+'
        } else {
          return Number(e).toLocaleString('ko-KR')
        }
      } else if (Number(e.replace(/[^0-9]/g, '')) > 99999) {
        return '99,999+'
      } else {
        return Number(e.replace(/[^0-9]/g, '')).toLocaleString('ko-KR')
      }
    },
    toggleChk (event) {
      this.$emit('toggle-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    alarmChk (event) {
      this.$emit('alarm-chk', {
        id: event.id,
        checked: event.chk
      })
    },
    newAlarmChk (event) {
      this.$emit('alarm-chk', {
        prodId: event.prodId,
        id: event.id,
        checked: event.chk
      })
    },
    unitHeight () {
      document.querySelectorAll('.goods-list.ugc.masonry > .goods-unit').forEach((el) => {
        // console.log(el.clientHeight)
        el.style.cssText = 'grid-row-end: span ' + (el.clientHeight + 0)
      })
    },
    prodClose (event) {
      this.$emit('prod-close', event)
    },
    changeSelect (event) {
      this.$emit('change-select', event)
    },
    selectItem (event) {
      if (!isNaN(event.idx)) {
        if (event.radio) {
          this.$refs['rdo_' + event.idx].click()
        } else {
          this.$refs['chk_' + event.idx].value = true
        }
      }
    },
    async addToCart (item) {
      this.sbpkSingle.pdNo = item.pdNo
      this.sbpkSingle.spbkQy = 1
      this.sbpkSingle.spbkSeCd = item.pkupDdcatYn === 'Y' ? '02' : '01'
      this.sbpkSingle.chnlCd = '01'
      this.sbpkSingle.onldPdNo = item.onlyOnlYn === 'Y' ? item.pdNo : ''
      if (this.pagePath.includes('/bulkOrder')) {
        this.sbpkSingle.spbkSeCd = '04'
        this.sbpkSingle.spbkQy = (item.htrkCnvMummQy ?? item.HTRK_CNV_MUMM_QY) * (item.jpQy ?? item.JP_QY)
      }
      this.sbpkSingle.exhPdNm = item.exhPdNm ? item.exhPdNm : '' // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.price = item.pdPrc ? item.pdPrc : '' // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.onlSclCd = item.onlSclCd ? item.onlSclCd : '' // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.brndNm = item.brndNm // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.optCn = '' // GTM 작업을 위한 파라미터 추가
      this.sbpkSingle.pkgYn = item.pkgYn // 패키지 여부
      this.sbpkSingle.pkgEpieceSleYn = item.pkgEpieceSleYn // 덕용상품낱개판매여부

      if (this.mbEid === undefined) { // 로그인 안했을때
        this.$router.push({ path: '/mb/mbb/SCR_MBB_0097A', param: { returnUrl: this.$route.fullPath } })
      } else if (this.mbEid !== undefined && item.optPdYn === 'Y') { // 상품 옵션이 있을때
        this.$confirm(Message.ko.PD.CART_OPTION, '', {
          confirmButtonText: '예',
          cancelButtonText: '아니요'
        }).then(() => { // 확인 버튼 클릭시
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: item.pdNo } })
        }).catch(() => { // 취소 버튼 또는 알림창 밖 클릭시

        })
      } else if (item.pkgYn === 'Y' && item.pkgEpieceSleYn === 'N') { // 덕용상품이고, 낱개판매 안할때
        this.$confirm(Message.ko.PD.CART_QY_OPTION, '', {
          confirmButtonText: '확인',
          cancelButtonText: '취소'
        }).then(() => { // 확인 버튼 클릭시
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: item.pdNo } })
        }).catch(() => { // 취소 버튼 또는 알림창 밖 클릭시

        })
      } else {
        const result = await this.addSpbk(this.sbpkSingle)
        this.showMsg(result)
      }
    },
    // 메시지 노출
    showMsg (result) {
      if (result.row > 0) {
        this.$confirm('장바구니에 추가되었습니다. 장바구니로 이동하시겠습니까?', '', {
          confirmButtonText: '확인',
          cancelButtonText: '취소',
          dangerouslyUseHTMLString: true
        }).then(() => {
          this.$router.push({ path: '/or/orc/SCR_ORC_0001' })
        }).catch(() => {
        })
      } else if (result.row === -1) {
        this.$alert('장바구니에 같은 상품이 있습니다.', '', {
          confirmButtonText: '확인'
        })
      } else {
        this.$alert('실패', '', {
          confirmButtonText: '확인'
        })
      }
    },
    async detailAdultCert (obj) { // 상품설명 클릭시 성인인증 필요한 상품 , 판매예정?상품 처리
      if (obj.buyLmtAgeCd === '03' && this.adltCtfcYn !== 'Y') {
        this.adultCert(obj)
      } else if (obj.wrhParmDt && obj.sleStsCd === '02') { // 판매예정인경우
        if (this.unitType === 'Release') {
          this.sendFeedback(obj)
          this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
        } else {
          await this.confirm(this.$t('PD.NOTIFY_PD_CONFIRM')).then(() => {
            this.sendFeedback(obj)
            this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
          })
        }
      } else {
        this.sendFeedback(obj)
        this.$router.push({ path: '/pd/pdr/SCR_PDR_0001', query: { pdNo: obj.pdNo, recmYn: this.recmYn ? 'Y' : 'N' } })
      }
    },
    sendFeedback (obj) {
      if (this.isNotEmpty(obj.keyword)) {
        const params = {
          ip: process.env.SSN_FD_IP,
          port: '5555', // 고정값
          collection: 'GOODS',
          keyword: obj.keyword,
          clickedId: obj.pdNo,
          clickCount: 1
        }
        this.$AxiosBuilder
          .params(params)
          .baseURL(process.env.API_SSN_FD_BASE_URL)
          .build()
          .get('/sendFeedback')
          .then((res) => {
            console.log(res)
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    exbtLazyControl () {
      if (!this.isLazyLoading) {
        this.activeExbt = true
        return
      }
      const selectedExbt = document.getElementById('exbt-' + this.item.exbtNo)

      if (this.isEmpty(selectedExbt)) {
        return
      }

      const options = {
        root: null,
        threshold: 0
      }

      const onSensor = (entries) => {
        console.log('entries  ', entries)
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            console.log('true ::: ')
            this.activeExbt = true
          } else {
            this.activeExbt = false
          }
        })
      }

      this.observer = new IntersectionObserver(onSensor, options)
      this.observer?.observe(selectedExbt)
    }
  }
}
